import { Component, Inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from './store/app.service';
import { environment } from '../environments/environment';
import { GoogleAnalyticsService } from './analytics/googleAnalytics.service';
import { DisplayDensityService } from './shared/services/display-density.service';
import { ThemeModeService } from './shared/services/theme-mode.service';
import * as util from './core/helpers/utility';
import { Constants } from './core/helpers/constants';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  reportViewLoading$!: Observable<boolean>;

  constructor(
    private router: Router,
    private appService: AppService,
    private cookieService: CookieService,
    private jwtHelperService: JwtHelperService,
    private readonly googleAnalyticsService: GoogleAnalyticsService,
    @Inject(DisplayDensityService)
    private readonly displayDensityService: DisplayDensityService,
    @Inject(ThemeModeService)
    private readonly themeModeService: ThemeModeService,
  ) {
    this.reportViewLoading$ = this.appService.getReportViewLoading$();
    this.displayDensityService.initialize();
    this.themeModeService.initialize();
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        appService.setActiveRoute$(val);
        this.syncSharedInstanceCookie();
      }
    });
  }
  ngOnInit()
  {
    this.syncSharedInstanceCookie();

    if (environment.production) {
      this.googleAnalyticsService.initialize();
      if (location.protocol === 'http:') {
        window.location.href = location.href.replace('http', 'https');
      }
    }
  }

  private syncSharedInstanceCookie(): void {
    const authToken = util.getAuthToken();
    if (!authToken || this.jwtHelperService.isTokenExpired(authToken)) {
      return;
    }

    const instanceKey = (localStorage.getItem(Constants.LS_CURRENT_INSTANCE) || '').toLowerCase();
    if (instanceKey !== 'ffm' && instanceKey !== 'prspr' && instanceKey !== 'cpjp') {
      return;
    }

    const expires = new Date();
    expires.setHours(expires.getHours() + 7);

    this.cookieService.set('CurrentInstance', instanceKey, {
      domain: environment.cookieDomain,
      expires,
      path: '/',
    });
  }

  title = 'ReachMe';
}
